import React, { useState } from 'react';
import './SuperAdminStyles.css';

const SystemSettings = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [metrics] = useState({
    newSubscriptions: 0,
    newBusinessRegistrations: 0,
    notSubscribed: 2
  });

  const [chartData] = useState([
    { month: 'Mar-2025', value: 5000, height: 22 },
    { month: 'Apr-2025', value: 0, height: 0 },
    { month: 'May-2025', value: 0, height: 0 },
    { month: 'Jun-2025', value: 22000, height: 100 },
    { month: 'Jul-2025', value: 10000, height: 45 },
    { month: 'Aug-2025', value: 11000, height: 50 },
    { month: 'Sep-2025', value: 0, height: 0 },
    { month: 'Oct-2025', value: 12000, height: 55 },
    { month: 'Dec-2025', value: 0, height: 0 }
  ]);

  const tabs = [
    { id: 'dashboard', label: 'Dashboard', icon: '📊' },
    { id: 'users', label: 'Users', icon: '👥' },
    { id: 'business', label: 'Business', icon: '🏢' },
    { id: 'subscription', label: 'Subscription', icon: '💳' },
    { id: 'settings', label: 'Settings', icon: '⚙️' },
    { id: 'reports', label: 'Reports', icon: '📈' }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return (
          <div className="tab-content">
            <h3>Dashboard Overview</h3>
            <div className="metric-cards-container">
              <div className="metric-card blue">
                <div className="metric-icon">
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
                  </svg>
                </div>
                <div className="metric-content">
                  <div className="metric-value">$ {metrics.newSubscriptions.toFixed(2)}</div>
                  <div className="metric-label">New Subscriptions</div>
                  <a href="#" className="metric-link">More Information →</a>
                </div>
              </div>

              <div className="metric-card light-blue">
                <div className="metric-icon">
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                    <circle cx="9" cy="7" r="4"/>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                  </svg>
                </div>
                <div className="metric-content">
                  <div className="metric-value">{metrics.newBusinessRegistrations}</div>
                  <div className="metric-label">New Business Registrations</div>
                  <a href="#" className="metric-link">More Information →</a>
                </div>
              </div>

              <div className="metric-card pink">
                <div className="metric-icon">
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/>
                    <polyline points="12 6 12 12 16 14"/>
                  </svg>
                </div>
                <div className="metric-content">
                  <div className="metric-value">{metrics.notSubscribed}</div>
                  <div className="metric-label">Not Subscribed</div>
                  <a href="#" className="metric-link">More Information →</a>
                </div>
              </div>
            </div>

            {/* Chart Section */}
            <div className="chart-section">
              <div className="chart-header">
                <h3>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ marginRight: '8px' }}>
                    <line x1="12" y1="20" x2="12" y2="10"/>
                    <line x1="18" y1="20" x2="18" y2="4"/>
                    <line x1="6" y1="20" x2="6" y2="16"/>
                  </svg>
                  Sale - Monthly for 12 months
                </h3>
                <button className="chart-menu-btn">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="3" y1="12" x2="21" y2="12"/>
                    <line x1="3" y1="6" x2="21" y2="6"/>
                    <line x1="3" y1="18" x2="21" y2="18"/>
                  </svg>
                </button>
              </div>
              
              <div className="custom-chart-container">
                <div className="chart-y-axis">
                  <div className="y-label">25k</div>
                  <div className="y-label">20k</div>
                  <div className="y-label">15k</div>
                  <div className="y-label">10k</div>
                  <div className="y-label">5k</div>
                  <div className="y-label">0</div>
                </div>
                <div className="chart-bars-container">
                  {chartData.map((data, index) => (
                    <div key={index} className="bar-wrapper">
                      <div className="bar-column">
                        <div 
                          className="bar" 
                          style={{ height: `${data.height}%` }}
                          title={`${data.month}: $${data.value.toLocaleString()}`}
                        >
                        </div>
                      </div>
                      <div className="bar-label">{data.month}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="chart-legend">
                <span className="legend-dot"></span>
                <span className="legend-text">Total Subscriptions (Dollars)</span>
              </div>
            </div>
          </div>
        );

      case 'users':
        return (
          <div className="tab-content">
            <h3>User Management</h3>
            <div className="content-placeholder">
              <p>User management interface will be displayed here.</p>
              <div className="placeholder-stats">
                <div className="stat-item">
                  <span className="stat-number">1,234</span>
                  <span className="stat-label">Total Users</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">89</span>
                  <span className="stat-label">Active Today</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">12</span>
                  <span className="stat-label">New This Week</span>
                </div>
              </div>
            </div>
          </div>
        );

      case 'business':
        return (
          <div className="tab-content">
            <h3>Business Management</h3>
            <div className="content-placeholder">
              <p>Business registration and management interface will be displayed here.</p>
              <div className="placeholder-stats">
                <div className="stat-item">
                  <span className="stat-number">456</span>
                  <span className="stat-label">Total Businesses</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">78</span>
                  <span className="stat-label">Active</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">5</span>
                  <span className="stat-label">Pending Approval</span>
                </div>
              </div>
            </div>
          </div>
        );

      case 'subscription':
        return (
          <div className="tab-content">
            <h3>Subscription Management</h3>
            <div className="content-placeholder">
              <p>Subscription plans and billing management will be displayed here.</p>
              <div className="placeholder-stats">
                <div className="stat-item">
                  <span className="stat-number">892</span>
                  <span className="stat-label">Active Subscriptions</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">$45,678</span>
                  <span className="stat-label">Monthly Revenue</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">23</span>
                  <span className="stat-label">Expiring Soon</span>
                </div>
              </div>
            </div>
          </div>
        );

      case 'settings':
        return (
          <div className="tab-content">
            <h3>System Settings</h3>
            <div className="content-placeholder">
              <p>System configuration and settings will be displayed here.</p>
              <div className="settings-grid">
                <div className="setting-item">
                  <h4>General Settings</h4>
                  <p>Basic system configuration</p>
                </div>
                <div className="setting-item">
                  <h4>Security Settings</h4>
                  <p>Authentication and authorization</p>
                </div>
                <div className="setting-item">
                  <h4>Email Settings</h4>
                  <p>Email server configuration</p>
                </div>
                <div className="setting-item">
                  <h4>Backup Settings</h4>
                  <p>Backup and restore options</p>
                </div>
              </div>
            </div>
          </div>
        );

      case 'reports':
        return (
          <div className="tab-content">
            <h3>Reports & Analytics</h3>
            <div className="content-placeholder">
              <p>Reports and analytics dashboard will be displayed here.</p>
              <div className="reports-grid">
                <div className="report-item">
                  <h4>Sales Report</h4>
                  <p>Monthly sales analysis</p>
                </div>
                <div className="report-item">
                  <h4>User Activity</h4>
                  <p>User engagement metrics</p>
                </div>
                <div className="report-item">
                  <h4>Financial Summary</h4>
                  <p>Revenue and expenses</p>
                </div>
                <div className="report-item">
                  <h4>System Performance</h4>
                  <p>System health metrics</p>
                </div>
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="superadmin-dashboard">
      <div className="dashboard-header">
        <h2>Welcome Superadmin</h2>
      </div>
      
      {/* Tabs Navigation */}
      <div className="tabs-container">
        <div className="tabs-nav">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="tab-icon">{tab.icon}</span>
              <span className="tab-label">{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="tabs-content">
        {renderTabContent()}
      </div>

      <div className="dashboard-footer">
        et-pos - V6.4 | Copyright © 2026 All rights reserved.
      </div>
    </div>
  );
};

export default SystemSettings;
